import { useAuthSelector } from "@risalabs_frontend_org/auth-wrapper";
import React from "react";
import { useDispatch } from "react-redux";
import { usePayerNameContextFromSingleOrderLayout } from "../../../../context/payerNameContextFromSingleOrderLayout";
import { ScreenNamesForBigQuery } from "../../../../../shared/enums/eventsData";
import { EventsName } from "../../../../../shared/enums/eventsName";
import { ModalId } from "../../../../../shared/enums/modalId";
import { setOpenedModalId } from "../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../redux/store/store";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";
import { apiWorkerManager } from "../../../../workerManagers/workerManager";
import DocuploadButton from "../../../modalOpener/modalOpener";
import NarLetterDelete from "../../../narLetterDelete/narLetterDelete";

interface Doc {
  id: string;
  isUploaded: boolean;
  uploaded_text?: string;
  doc_type: string;
  doc_id?: string;
  text_to_display?: string;
  doc_upload_status?: string;
  j_code?: string;
}

interface StringWithButtonCellProps {
  value: {
    docs: Doc[];
    authStatus: any;
    doc_upload_status?: string;
    patient_id?: string;
    order_id?: string;
    shouldLogEvent?: boolean;
    documentsList?: { value: string; label: string }[];
    documentsLoading?: boolean;
  };
  [key: string]: any;
}

export const StringWithButtonCell: React.FC<StringWithButtonCellProps> = ({
  value,
}) => {
  const { user } = useAuthSelector((state) => state.firebaseAuthentication);
  const dispatch = useDispatch<AppDispatch>();
  const { payerName } = usePayerNameContextFromSingleOrderLayout();
  const allDocs = value.docs;

  if (allDocs && allDocs.length === 0) {
    return <></>;
  }

  const handleDocUploadButtonClick = (doc: Doc) => {
    value?.shouldLogEvent &&
      apiWorkerManager.enqueueAndProcess({
        patient_id: value?.patient_id ?? "",
        order_id: value?.order_id ?? "",
        org_id: getOrgIdForFetchExternalWorklist() || "",
        user_id: user?.id ?? "",
        user_email: user?.email ?? "",
        event_name:
          EventsName.UPLOAD_DOCUMENT_BUTTON_CLICKED +
          " (" +
          doc?.j_code +
          " " +
          doc?.doc_type +
          ")",
        additional_data: {
          doc_type: doc?.doc_type,
          j_code: doc?.j_code,
          screen_name: ScreenNamesForBigQuery.AUTH_STATUS_SCREEN,
          payer_name: payerName,
        },
      });
  };

  return (
    <>
      <div className="flex w-full flex-row items-center justify-end gap-2">
        {allDocs.map((doc, index) => {
          return (
            <div
              key={(doc?.uploaded_text ?? "") + "_" + doc.doc_id + "_" + index}
            >
              {doc.isUploaded ? (
                <NarLetterDelete
                  title={doc?.uploaded_text ?? ""}
                  exitDirection="right"
                  docType={doc?.doc_type}
                  docId={doc?.doc_id}
                  docUploadStatus={value?.doc_upload_status ?? ""}
                  onClick={() => {
                    dispatch(
                      setOpenedModalId({
                        id: ModalId.DOC_VIEWER_MODAL_WITH_TITLE,
                        metaData: {
                          authStatus: value.authStatus,
                          docData: doc,
                        },
                      }),
                    );
                  }}
                />
              ) : (
                <DocuploadButton
                  title={doc?.text_to_display ?? ""}
                  onClick={() => {
                    handleDocUploadButtonClick(doc);
                    dispatch(
                      setOpenedModalId({
                        id: ModalId.NAR_LETTER_MODAL,
                        metaData: {
                          authStatus: value.authStatus,
                          docType: doc?.doc_type,
                          documentsList: value?.documentsList ?? [],
                          documentsLoading: value?.documentsLoading ?? false,
                        },
                      }),
                    );
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default StringWithButtonCell;
